import palette from './palette'

export default {
  h1: {
    color: palette.text.primary,
    fontWeight: 'bold',
    fontSize: '1.5rem', // 24px
    letterSpacing: '-0.24px',
    lineHeight: '40px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 'bold',
    fontSize: '1.313rem', // 21px
    letterSpacing: '-0.24px',
    lineHeight: '32px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 'bold',
    fontSize: '1.188rem', // 19px
    letterSpacing: '-0.06px',
    lineHeight: '28px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '1.063rem', // 17px
    letterSpacing: '-0.06px',
    lineHeight: '30px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 900,
    fontSize: '0.938rem', // 15px
    letterSpacing: '-0.05px',
    lineHeight: '20px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '0.813rem', // 13px
    letterSpacing: '-0.05px',
    lineHeight: '20px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '1.2rem', // 19px
    letterSpacing: '-0.05px',
    lineHeight: '25px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  subtitle2: {
    color: palette.text.primary,
    fontSize: '0.875rem', // 14px
    letterSpacing: '-0.05px',
    lineHeight: '21px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(','),
    paddingBottom: '1em'
  },
  body1: {
    color: palette.text.primary,
    fontSize: '0.938rem', // 15px
    letterSpacing: '-0.05px',
    lineHeight: '21px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  body2: {
    color: palette.text.primary,
    fontSize: '0.875rem', // 14px
    letterSpacing: '-0.04px',
    lineHeight: '18px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  button: {
    color: palette.text.primary,
    fontSize: '0.9rem', // 14.4px
    fontWeight: 600,
    fontFamily: ['Proxima Nova', 'sans-serif'].join(','),
    textTransform: 'none'
  },
  caption: {
    color: palette.text.primary,
    fontSize: '0.813rem', // 13px
    letterSpacing: '0.33px',
    lineHeight: '13px',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  },
  overline: {
    color: palette.text.primary,
    fontSize: '0.75rem', // 12px
    fontWeight: 100,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'none',
    fontFamily: ['Proxima Nova', 'sans-serif'].join(',')
  }
}
